<template>
    <div class="center w-full h-full overflow-hidden
        p-0 xl:px-5 lg:px-3 md:px-2">
		<div class="flex w-full h-full justify-content-center align-items-center" style="min-height: 40px;">
			<div v-if="accounts && accounts.length" class="flex flex-row w-full h-full p-3 gap-3 text-400 font-medium text-sm">
                <div v-for="(account, index) in accounts" :key="index" class="flex flex-row gap-2 align-items-center" v-tooltip="`Баланс ${(account.currency) ? account.currency.toUpperCase() : ''}`">
                    <img :src="`/images/icons/svg/currencies/${account.currency.toLowerCase()}.svg`" class="border-circle" style="width:20px!important;height:20px!important"/>
                    <span class="flex" v-if="account.balance && account.currency">
                        {{ getFormatAmount(account.balance, account.currency) }}
                    </span>
                </div>
			</div>
		</div>
	</div>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'
import { useRouter } from 'vue-router'

export default {
    data() {
        return {
            dialog: false,
            personal: [],
            admin: [],
            logout: [
                {
                    label: 'Выйти',
                    icon: null,
                    route: '/logout/'
                },
            ]
        }
    },
    computed: {
        isAuth: function () { return this.$store.getters.isAuthenticated },
        accessCodes: function () { return this.$store.getters.StateUserAccessCodes },
        screenSize() { return this.$store.getters.StateScreenSize },
        accounts() { return this.$store.getters.StateAccountDetails },
    },
    components: {

    },
    methods: {
        getFormatAmount(value, currency, digits=0) {
            return this.helper.format_amount(value, currency, digits)
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
        this.router = useRouter()
    },
    async mounted() {

    },
}
</script>